import React from "react";
import {BaseFragment, BaseFragmentProps, BaseFragmentState} from "./BaseFragment";
import {Login} from "./Login";
import {getMemberAuth} from "./auth";
import {Button} from "@mui/material";
import {PD_MD} from "./dimens";
import {HomeOutlined} from "@mui/icons-material";

export type LoginFragmentProps = BaseFragmentProps & {}

type LoginFragmentState = BaseFragmentState & {}

export class LoginFragment extends BaseFragment<LoginFragmentProps, LoginFragmentState> {

  renderContainerContent(): React.ReactElement {
    const memberAuth = getMemberAuth();
    let redirectPath;
    const paramsString = window.location.search;
    if (paramsString) {
      const searchParams = new URLSearchParams(paramsString);
      redirectPath = searchParams.get("r")?.trim();
    }
    if (!redirectPath) {
      redirectPath = "/";
    }
    if (memberAuth?.auth?.currentUser) {
      this.props.path.navigate(redirectPath);
      return null;
    }
    return <>
      <Button startIcon={<HomeOutlined/>} style={{position: "absolute", left: PD_MD, top: PD_MD}} onClick={() => this.props.path.navigate("/")}>Go Home</Button>
      <Login redirectPath={redirectPath}/>
    </>;
  }
}
